<div class="content-qr">
  <div class="content-qr-container">
    <div class="container-title px-4">
      <h1>Cobro Monto Abierto</h1>
      <mat-icon
        class="info-icon pr-3"
        #myInfoTooltip="matTooltip"
        matTooltip="Al escanear el QR la billetera deberá ingresar el monto de la operación"
        (click)="myInfoTooltip.show()"
        >info</mat-icon
      >
    </div>
    <div class="center-groups">
      <div class="branch-selector" *ngIf="this.commerceUser || this.userResponsible">
        <form [formGroup]="qrForm">
          <mat-form-field class="input-yaca">
            <mat-label>{{ 'pages.cashiers.labels.branch_office_select' | translate }}</mat-label>
            <mat-select
              #branchSelect
              formControlName="branchOffice"
              (selectionChange)="generateQR(qrForm.get('branchOffice').value.value)"
            >
              <mat-option *ngFor="let branch of branchOfficesCollection" [value]="branch">
                {{ branch.display }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      </div>
      <div class="qr-container">
        <div
          *ngIf="QRimgSrc === ''"
          style="
            height: 269px;
            width: 280px;
            display: flex;
            align-content: center;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <mat-spinner></mat-spinner>
        </div>
        <div class="complete-profile-text" *ngIf="completeProfile">
          <span>Por favor, complete su perfil desde su celular para generar un QR.</span>
        </div>
        <div>
          <img class="qr-img" src="{{ QRimgSrc }}" *ngIf="QRimgSrc" />
          <div #userQRCont id="userQR"></div>
        </div>
      </div>
      <div class="buttons-box" *ngIf="!completeProfile">
        <div class="datos">
          <span class="title">{{ name }}</span
          ><br />
          <span *ngIf="branchName">{{ 'pages.cashiers.labels.qr_sucursal' | translate }} {{ branchName }}</span
          ><br />
          <span>{{ 'pages.cashiers.labels.qr_cuilCuit' | translate }} {{ this.cuilCuit }}</span
          ><br />
          <span *ngIf="domicilio">{{ 'pages.cashiers.labels.qr_ubicacion' | translate }} {{ domicilio }}</span>
        </div>
        <button mat-button id="imprimir" class="button-print" [disabled]="buttonImprimir" #imprimir (click)="printQR()">
          <svg width="46" height="35" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M38.3335 31.3049C38.3335 32.0102 37.7872 32.5833 37.1126 32.5833H35.4585V28.75C35.4585 26.6359 33.7392 24.9167 31.6252 24.9167H14.3752C12.2611 24.9167 10.5418 26.6359 10.5418 28.75V32.5833H8.88775C8.21308 32.5833 7.66683 32.0102 7.66683 31.3049V18.5284C7.66683 17.8231 8.21308 17.25 8.88775 17.25H11.5002H15.3335H30.6668H34.5002H37.1126C37.7872 17.25 38.3335 17.8231 38.3335 18.5284V31.3049ZM14.3752 36.4167V28.75H31.6252L31.629 36.4167H14.3752ZM15.3602 9.58333H30.6667V13.4167H15.3468L15.3602 9.58333ZM37.1126 13.4167H34.5002V9.58333C34.5002 7.46925 32.9247 5.75 30.9869 5.75H15.0134C13.0757 5.75 11.5002 7.46925 11.5002 9.58333V13.4167H8.88775C6.10091 13.4167 3.8335 15.709 3.8335 18.5284V31.3049C3.8335 34.1243 6.10091 36.4167 8.88775 36.4167H10.5418C10.5418 38.5307 12.2611 40.25 14.3752 40.25H31.6252C33.7392 40.25 35.4585 38.5307 35.4585 36.4167H37.1126C39.8994 36.4167 42.1668 34.1243 42.1668 31.3049V18.5284C42.1668 15.709 39.8994 13.4167 37.1126 13.4167V13.4167Z"
              fill="#FF6600"
            />
          </svg>
          <span style="color: #ff6600">Imprimir QR</span>
        </button>
        <div class="spacer"></div>
        <button
          *ngIf="!spinnerDownload"
          mat-button
          id="imprimir"
          class="button-print"
          [disabled]="buttonImprimir"
          #imprimir
          (click)="downloadQR()"
          color="clear"
        >
          <svg width="46" height="35" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M35.9726 25.6067C35.2941 24.7941 34.0866 24.6829 33.2739 25.3614L24.9173 32.3247V9.58341C24.9173 8.52541 24.0586 7.66675 23.0006 7.66675C21.9426 7.66675 21.0839 8.52541 21.0839 9.58341V32.3247L12.7273 25.3614C11.9127 24.6829 10.7052 24.7941 10.0286 25.6067C9.35011 26.4194 9.45936 27.6288 10.2739 28.3054L21.7739 37.8887C21.864 37.9654 21.9714 38.0018 22.071 38.0593C22.1496 38.1053 22.2186 38.159 22.3049 38.1935C22.5291 38.2817 22.7629 38.3334 23.0006 38.3334C23.2383 38.3334 23.4721 38.2817 23.6964 38.1935C23.7826 38.159 23.8516 38.1053 23.9302 38.0593C24.0299 38.0018 24.1372 37.9654 24.2273 37.8887L35.7273 28.3054C36.5399 27.6288 36.6511 26.4194 35.9726 25.6067"
              fill="#FF6600"
            />
          </svg>
          <span style="color: #ff6600">Descargar PDF completo</span>
        </button>
        <div *ngIf="spinnerDownload">
          <mat-spinner [diameter]="35"></mat-spinner>
        </div>
      </div>
      <button mat-stroked-button class="back-button" color="primary" (click)="goBack()">Volver</button>
      <div style="margin-top: 20px; width: 100%"></div>
    </div>

    <div #pdfContent class="pdfContent">
      <div id="qr-to-download">
        <div class="left">
          <div class="orange-header"></div>
          <div class="info-container">
            <div class="patch"></div>
            <div class="border-corners">
              <span class="posnet-label"
                >¡Escaneá el <br />
                <strong>QR </strong>
                <img
                  src="../../../assets/images/logos/pdf-qr/posnet.png"
                  alt="posnet-logo"
                  style="margin-bottom: 5px"
                />
                y pagá!
              </span>
            </div>
            <div>
              <img class="qr-img" src="{{ QRimgSrc }}" *ngIf="QRimgSrc" width="200px" height="200px" />
              <div #userQRCont id="userQR"></div>
            </div>
            <div style="text-align: center; margin-bottom: 20px">
              <span style="font-size: 25px" class="uni-55">Todas las billeteras</span>
              <br />
              <span style="font-size: 20px" class="uni-45">con dinero en cuenta</span>
            </div>
            <img src="../../../assets/images/logos/pdf-qr/modo.png" alt="modo-logo" width="200px" height="48px" />
            <div class="logos-container-left">
              <img src="../../../assets/images/logos/pdf-qr/mercadopago-literal.png" alt="mercado-pago-logo" />
              <img
                src="../../../assets/images/logos/pdf-qr/cuenta_dni.png"
                alt="cuenta-dni-logo"
                width="100px"
                height="40px"
              />
              <img src="../../../assets/images/logos/pdf-qr/appbancarias.png" alt="cuenta-dni-logo" />
            </div>
          </div>
        </div>
        <div class="right">
          <div class="orange-header"></div>
          <div class="info-container" style="margin-bottom: 30px">
            <span style="font-size: 40px; text-align: center; color: black" class="uni-55"
              >Aceptamos todas <br />
              las billeteras</span
            >
            <img src="../../../assets/images/logos/pdf-qr/modo.png" alt="modo-logo" width="200px" height="48px" />
            <div class="logos-container-right">
              <div>
                <img
                  src="../../../assets/images/logos/pdf-qr/cuenta_dni.png"
                  alt="cuenta-dni-logo"
                  width="130px"
                  height="60px"
                />
              </div>
              <div>
                <img
                  src="../../../assets/images/logos/pdf-qr/personalpay_positivo.png"
                  alt="cuenta-dni-logo"
                  width="220px"
                  height="60px"
                />
              </div>
              <div>
                <img src="../../../assets/images/logos/pdf-qr/mercadopago-literal.png" alt="mercado-pago-logo" />
              </div>
              <div>
                <img
                  src="../../../assets/images/logos/pdf-qr/uala.png"
                  alt="cuenta-dni-logo"
                  width="60px"
                  height="50px"
                />
              </div>
              <div>
                <img
                  src="../../../assets/images/logos/pdf-qr/naranjax.png"
                  alt="cuenta-dni-logo"
                  width="130px"
                  height="34px"
                />
              </div>
              <div>
                <img src="../../../assets/images/logos/pdf-qr/appbancarias.png" alt="cuenta-dni-logo" />
              </div>
            </div>
            <div class="footer-right">
              <div class="footer-logo-container">
                <div class="footer-logos-left">
                  <img src="../../../assets/images/logos/pdf-qr/posnet-clover-carat.png" alt="posnet-clover-carat" />
                </div>
                <div class="footer-logos-right">
                  <img src="../../../assets/images/logos/pdf-qr/fiserv_small.png" alt="scissor-icon" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="scissor1" class="scissor">
        <img src="../../../assets/icons/scissors.png" alt="scissor-icon" width="20px" height="20px" />
      </div>
      <div id="scissor2" class="scissor">
        <img src="../../../assets/icons/scissors.png" alt="scissor-icon" width="20px" height="20px" />
      </div>
    </div>
  </div>
</div>
